import axios, { AxiosResponse } from 'axios'

const backendDomain: string = process.env.NODE_ENV === 'development' ? 
  'http://localhost:3030'
 : 'https://esl-fresh-integration.up.railway.app'


export async function getAccount(mondayAccountId: number, accessToken: string): Promise<any | undefined> {
  try {
    const res: AxiosResponse = await axios.get(`${backendDomain}/account/${mondayAccountId}`, {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
    const account: any = res.data

    return account
  } catch (error) {
    console.log('file: accountService.ts -> line 13 -> getAccount -> error', error)
  }
}

export async function updateAccount(account: Account, accessToken: string): Promise<any> {
  try {
    await axios.put(`${backendDomain}/account`, account, {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    })
  } catch (error) {
    console.log('file: accountService.ts -> line 21 -> updateAccount -> error', error)
  }
}

export async function createAccount(mondayAccountId: number) {
  
  try { 
    const res: AxiosResponse = await axios.post(`${backendDomain}/account/${mondayAccountId}`)
    const account = res.data

    return account
  } catch(error) {
    console.log("file: accountService.ts -> line 31 -> createAccount -> error", error)
  }
}

function checkUserLicense(account: Account, boardsMappingLength: number): boolean {
  if ((account.licenseEndAt! < account.boughtLicenseAt!) && boardsMappingLength >= 1) return false
  else if ((boardsMappingLength >= 1 && account.license === 'free') || (account.license === 'pro' && boardsMappingLength >= 5) || (account.license === 'business' && boardsMappingLength >= 10)) return false
  else return true
}

export async function login(mondayAccountId: number) {
  try {
    const res: AxiosResponse = await axios.post(`${backendDomain}/login`, {mondayAccountId})
    const {accessToken} = res.data
    return accessToken
  } catch(error) {
  console.log('file: accountService.ts:53 -> error', error)
  }
}

function setAccessTokenAsCookie(accessToken: string) {
  document.cookie = `jwt=${accessToken}; expires=${_getExpirationDate()}; path=/`;
}

function _getExpirationDate() {
  const expirationInDays = 7;
  const expirationDate = new Date();
  expirationDate.setTime(expirationDate.getTime() + (expirationInDays * 24 * 60 * 60 * 1000));
  return expirationDate.toUTCString();
}

function getAccessTokenFromCookie() {
  const name = 'jwt=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export const accountService = {
  getAccount,
  updateAccount,
  createAccount,
  checkUserLicense,
  login,
  setAccessTokenAsCookie,
  getAccessTokenFromCookie
}
